@if (!loading()) {
  <div class="card-wrapper">
    <mat-card>
      <mat-card-header>
        <mat-card-title> Persoonsgegevens invullen </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="personalForm">
          <mat-form-field hideRequiredMarker="true">
            <mat-label>Voor- & achternaam</mat-label>
            <input matInput type="text" formControlName="name" autocomplete="name" />
            @if (personalForm.controls.name.hasError('required')) {
              <mat-error>Voor- & achternaam is verplicht.</mat-error>
            }
          </mat-form-field>
          @if (dataStore.publicSettings.askBirthDay || dataStore.publicSettings.askGender) {
            <div class="partial-form-fields">
              @if (dataStore.publicSettings.askBirthDay) {
                <mat-form-field hideRequiredMarker="true">
                  <mat-label>Geboortedatum</mat-label>
                  <input
                    formControlName="birthDate"
                    autocomplete="bday"
                    matInput
                    [matDatepicker]="picker"
                    placeholder="Geboortedatum"
                  />
                  <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  @if (personalForm.controls.birthDate.hasError('required')) {
                    <mat-error>Geboortedatum is verplicht.</mat-error>
                  }
                </mat-form-field>
              }
              @if (dataStore.publicSettings.askGender) {
                <mat-form-field hideRequiredMarker="true">
                  <mat-label>Geslacht</mat-label>
                  <mat-select formControlName="gender">
                    <mat-option value="Man">Man</mat-option>
                    <mat-option value="Vrouw">Vrouw</mat-option>
                    <mat-option value="Anders">Anders</mat-option>
                  </mat-select>
                  @if (personalForm.controls.gender.hasError('required')) {
                    <mat-error>Geslacht is verplicht.</mat-error>
                  }
                </mat-form-field>
              }
            </div>
          }
          <div class="partial-form-fields">
            <mat-form-field hideRequiredMarker="true">
              <mat-label>Postcode</mat-label>
              <input matInput type="text" formControlName="postal" autocomplete="postal-code" />
              @if (personalForm.controls.postal.hasError('required')) {
                <mat-error>Postcode is verplicht.</mat-error>
              }
              @if (personalForm.controls.postal.hasError('postalValidator')) {
                <mat-error>Vul een geldige postcode in.</mat-error>
              }
            </mat-form-field>
            <mat-form-field hideRequiredMarker="true">
              <mat-label>Huisnummer</mat-label>
              <input
                matInput
                type="text"
                formControlName="houseNumber"
                autocomplete="address-line2"
                (input)="formatNumericInput($event, personalForm, 'houseNumber', true)"
              />
              @if (personalForm.controls.houseNumber.hasError('required')) {
                <mat-error>Huisnummer is verplicht.</mat-error>
              }
              @if (
                personalForm.controls.houseNumber.hasError('numberInput') ||
                personalForm.controls.houseNumber.hasError('pattern')
              ) {
                <mat-error>Vul een geldig huisnummer in.</mat-error>
              }
            </mat-form-field>
            <mat-form-field hideRequiredMarker="true">
              <mat-label>Toevoeging</mat-label>
              <input matInput type="text" formControlName="houseNumberAddition" />
              <mat-hint>Optioneel</mat-hint>
            </mat-form-field>
          </div>
          <div class="partial-form-fields">
            <mat-form-field hideRequiredMarker="true">
              <mat-label>Straatnaam</mat-label>
              <input readonly matInput type="text" formControlName="streetName" autocomplete="address-line1" />
              @if (postcodeApiService.fetchingAddress()) {
                <mat-spinner [diameter]="18" class="field-centered-spinner"></mat-spinner>
              }
              @if (personalForm.controls.streetName.hasError('required')) {
                <mat-error>Straatnaam is verplicht.</mat-error>
              }
            </mat-form-field>
            <mat-form-field hideRequiredMarker="true">
              <mat-label>Woonplaats</mat-label>
              <input readonly matInput type="text" formControlName="city" autocomplete="address-level2" />
              @if (postcodeApiService.fetchingAddress()) {
                <mat-spinner [diameter]="18" class="field-centered-spinner"></mat-spinner>
              }
              @if (personalForm.controls.city.hasError('required')) {
                <mat-error>Woonplaats is verplicht.</mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field hideRequiredMarker="true">
            <mat-label>E-mailadres</mat-label>
            <input matInput type="text" formControlName="email" autocomplete="email" />
            @if (personalForm.controls.email.hasError('required')) {
              <mat-error>E-mailadres is verplicht.</mat-error>
            }
            @if (personalForm.controls.email.hasError('emailValidator')) {
              <mat-error>Vul een geldig e-mailadres in.</mat-error>
            }
          </mat-form-field>
          <div
            class="tel-input-wrapper"
            [ngClass]="{
              'tel-input-error':
                ((personalForm.controls.phoneNumber.hasError('validatePhoneNumber') &&
                  personalForm.controls.phoneNumber.touched) ||
                  (personalForm.controls.phoneNumber.hasError('required') &&
                    personalForm.controls.phoneNumber.touched)) &&
                !personalForm.controls.phoneNumber.disabled,
              'tel-input-disabled': personalForm.controls.phoneNumber.disabled,
            }"
          >
            <ngx-intl-tel-input
              [cssClass]="'tel-input-input'"
              [preferredCountries]="[CountryISO.Netherlands]"
              [enableAutoCountrySelect]="false"
              [enablePlaceholder]="true"
              customPlaceholder="Mobiel telefoonnummer"
              [searchCountryFlag]="false"
              [selectFirstCountry]="false"
              [selectedCountryISO]="CountryISO.Netherlands"
              [separateDialCode]="true"
              [phoneValidation]="true"
              name="phone"
              formControlName="phoneNumber"
              matInput
            >
            </ngx-intl-tel-input>
            @if (personalForm.controls.phoneNumber.hasError('required') && personalForm.controls.phoneNumber.touched) {
              <mat-error class="phone-error">Mobiel telefoonnummer is verplicht.</mat-error>
            }
            @if (
              personalForm.controls.phoneNumber.hasError('validatePhoneNumber') &&
              personalForm.controls.phoneNumber.touched
            ) {
              <mat-error class="phone-error">Vul een geldig mobiel telefoonnummer in.</mat-error>
            }
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-flat-button
          [class.spinner]="awaitingResponse()"
          [disabled]="awaitingResponse() || !personalForm.valid || postcodeApiService.fetchingAddress()"
          (click)="finishRegistration()"
        >
          Opslaan en verder gaan
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
}
@if (loading()) {
  <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
